export default "__VITE_ASSET__DvpcVDBd__"